import { io, Socket } from "socket.io-client";
import { SOCKET_URL } from "./api";

let socket: Socket | null = null;

export function getSocket(token: string): Socket {
  // Ne JAMAIS remplacer un socket déjà créé simplement parce qu'il n'est pas "connected" à cet
  // instant : pendant la poignée de main (juste après sa création), connected vaut encore false,
  // et plusieurs appels à getSocket() se produisant à ce moment-là (plusieurs composants/effets
  // qui montent en même temps) recréaient un nouveau socket à chaque fois — orphelinant les
  // listeners ("new_message"...) déjà attachés au précédent. Résultat : l'envoi fonctionnait
  // (le dernier socket créé recevait bien les emit), mais aucun message reçu en direct n'était
  // jamais affiché tant que la page n'était pas rechargée. Socket.IO gère lui-même la
  // reconnexion automatique sur cette même instance : pas besoin d'en recréer une ici.
  if (socket) return socket;

  socket = io(SOCKET_URL, {
    auth: { token },
    transports: ["websocket", "polling"],
  });
  socket.on("connect", () => {
    socket?.emit("join_conversations");
  });
  return socket;
}

export function disconnectSocket() {
  socket?.disconnect();
  socket = null;
}
